"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _T3QB4FR3cjs = require('./T3QB4FR3.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/focusable/focusable-container.tsx
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useFocusableContainer = _PTOCUU2Dcjs.createHook.call(void 0, function useFocusableContainer2({ autoFocusOnShow = true, ...props }) {
  props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
    props,
    (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _T3QB4FR3cjs.FocusableContext.Provider, { value: autoFocusOnShow, children: element }),
    [autoFocusOnShow]
  );
  return props;
});
var FocusableContainer = _PTOCUU2Dcjs.forwardRef.call(void 0, function FocusableContainer2(props) {
  const htmlProps = useFocusableContainer(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useFocusableContainer = useFocusableContainer; exports.FocusableContainer = FocusableContainer;
